export default __webpack_public_path__ + "static/lalibrairie-jl-desktop-e6c44578adb676e82d51a44d5c5d820f.jpg";